import React, { useCallback } from 'react';
import InecoRiskDefault from './CardSwitch/InecoRiskDefault';

export default function ElementContainer({ elementID, type }) {
  const ResourcesSwitch = useCallback(() => {
    switch (type) {
      default:
      case 'ineco':
        return <InecoRiskDefault elementID={elementID} />;
    }
  }, [elementID, type]);

  return (
    <div className="pt-2">
      <ResourcesSwitch />
    </div>
  );
}
